import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { LoadingController, ModalController, ToastController } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { MdlChatsBotPage } from 'src/app/pages/mdl-chats-bot/mdl-chats-bot.page';
import { WhatsappService } from 'src/app/services/whatsapp.service';
import { ValidarToken } from 'src/app/validators/valida-datos';

@Component({
  selector: 'app-reportes-chats-bot',
  templateUrl: './reportes-chats-bot.component.html',
  styleUrls: ['./reportes-chats-bot.component.scss'],
})
export class ReportesChatsBotComponent implements OnInit {

  idAdmin: string;
  vista: number;
  fechaInicial: any;
  fechaFinal: any;
  loading: any;
  conversaciones: any;
  arrConver: any;
  classUser: any;
  canal: any;
  canales: any;
  canalInicial: any;

  constructor(
    private storage: Storage,
    private serviceWa: WhatsappService,
    private loadingController: LoadingController,
    private toastCtrl: ToastController,
    private modalCtrl: ModalController,
    private formatdate: DatePipe,
  ) {
    this.canales = [];
    this.fechaFinal = new FormControl('');
    this.fechaInicial = new FormControl('');
  }

  ngOnInit() {
    this.getCanal();
    this.vista = 0;
    this.conversaciones = [];
    this.arrConver = [];
  }

 

  async getCanal() {
    this.canal = await this.storage.get('canal').then();
    this.canales = await this.storage.get('canales').then();
      // console.log(this.canales, 'canales ');
      this.canalInicial = this.canales.find(canal => canal.canale.idAdmin_sec == this.canal.idAdmin_sec);
      this.idAdmin = this.canalInicial.canale.idAdmin_sec;
      this.classUser = this.canalInicial;
    // console.log(this.canal.url_back, 'url de back desde storage');
  }

  consulta(val) {
    this.presentLoading('Cargando Visitantes...');
    let query = ``;
    if(val === 1) {
      const feIn = new Date(this.fechaInicial.value);
      const feFin = new Date(this.fechaFinal.value);
      feIn.setHours(0, 0, 0);
      feFin.setHours(23, 59, 59);
      // console.log(feIn);
      // console.log(feFin);
      query = `fechaI=${feIn}&fechaF=${feFin}`;
    }
    // console.log(query);
    this.serviceWa.getHistorialChatsBot(query, this.idAdmin, this.classUser.id, this.classUser.rol,
      this.classUser.token, this.classUser.canale.url_back).subscribe(
      (res: any)=>{
      // console.log(res, this.idAdmin, this.classUser.id);
      this.loading.dismiss();

        const {status, message} = res;
        if(status ==='success'){
         const {numeros} = res;
         this.conversaciones = numeros;
        //  this.formatTable(this.conversaciones);
        //  this.conversaciones.forEach(element => {
        //   element.conversacion.createdAt = new Date(element.conversacion.createdAt);
        //  });
        //  console.log(this.conversaciones);
         this.presentToast('Datos encontrados!', 'success');
         this.vista = 1;
        }
        else{
         this.presentToast('No se encontrarón conversaciones', 'danger');
        }
    },
    erro => {
      console.log(erro);
      this.loading.dismiss();
    });

  }

  // formatTable(conversaciones) {
  //   this.arrConver = conversaciones.map((conver) =>( {
  //       // eslint-disable-next-line @typescript-eslint/naming-convention
  //       Telefono: conver.cliente,
  //       // eslint-disable-next-line @typescript-eslint/naming-convention
  //       Nombre: conver.nombreCliente,
  //       // eslint-disable-next-line @typescript-eslint/naming-convention
  //       'Inicio de conversación': this.formatdate.transform(conver.conversacion.createdAt, 'dd/MM/yyyy HH:mm:ss'),
  //       // eslint-disable-next-line @typescript-eslint/naming-convention
  //       'Fin de conversación': this.formatdate.transform(conver.finConversacion, 'dd/MM/yyyy HH:mm:ss'),
  //       // eslint-disable-next-line @typescript-eslint/naming-convention
  //       Agente: conver.agente,
  //       // eslint-disable-next-line @typescript-eslint/naming-convention
  //       Estatus: conver.statusConver,
  //       // eslint-disable-next-line @typescript-eslint/naming-convention
  //       'No. conversación': conver.conversacion.conversacion,
  //       // eslint-disable-next-line quote-props
  //       // eslint-disable-next-line @typescript-eslint/naming-convention
  //       // 'Calificación': conver.calificacion.calificacion,
  //       // eslint-disable-next-line @typescript-eslint/naming-convention
  //       'Otra Respuesta Calificación': conver.calificacion.otraRes,

  //   }));
  // }

  descargar() {
    this.serviceWa.exportAsExcelFile(this.arrConver, `Reporte-Conversaciones-${this.formatdate.transform(new Date(),
      'dd-MM-yyyy-HH-mm-ss')}`);
  }

  async openMdl(numero, inicio, fin) {
    const modal = await this.modalCtrl.create({

      component: MdlChatsBotPage,
      componentProps: {
        idAdmin: this.idAdmin,
        numero,
        inicio,
        fin
      },
      cssClass: 'modalChats'
    });

    await modal.present();

    const { data } = await modal.onWillDismiss();
  }

  async presentLoading(mensaje) {
    this.loading = await this.loadingController.create({
      spinner:'dots',
      //message: mensaje,
      cssClass:'loaderGeneral',
      message:'<ion-img src="../../../assets/images/logoVabelLoading.png"></ion-img>'
    });
  await this.loading.present();
}

  async presentToast(message, color) {
    const toast = await this.toastCtrl.create({
      message,
      duration: 3000,
      color
    });
    toast.present();
  }

}
